import { render, staticRenderFns } from "./PenaltyComponent.vue?vue&type=template&id=2ce19cbb&scoped=true"
import script from "./PenaltyComponent.vue?vue&type=script&lang=js"
export * from "./PenaltyComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce19cbb",
  null
  
)

export default component.exports